import { useMemo } from "react";
import { BarCharts, GraphicsDomain } from "../interfaces/Indicator";
import { getDomain } from "../utils/utils";
import { getSearchPredicate } from "../views/IndicatorDisplay/utils/helpers";
import { INDICATOR_TYPE_RESULTS } from "../utils/const";

export const useChartDomains = (
    data: BarCharts[],
    leftVariables: string[],
    rightVariable: string | null,
    rangeLeft: GraphicsDomain | null,
    rangeRight: GraphicsDomain | null
) => {
    const domainYLeft = useMemo<[number, number] | [string, string]>(() => {
        if (rangeLeft && rangeLeft.minimo != null && rangeLeft.maximo != null) {
            return [rangeLeft.minimo, rangeLeft.maximo];
        }
        return getDomain(data, getSearchPredicate(INDICATOR_TYPE_RESULTS, leftVariables));
    }, [data, leftVariables, rangeLeft]);

    const domainYRight = useMemo<[number, number] | [string, string]>(() => {
        if (!rightVariable?.length) return ['auto', 'auto'];

        if (rangeRight?.minimo != null && rangeRight?.maximo != null) {
            return [rangeRight.minimo, rangeRight.maximo];
        }
        return getDomain(data, getSearchPredicate(INDICATOR_TYPE_RESULTS, [rightVariable]));
    }, [data, rightVariable, rangeRight]);

    return { domainYLeft, domainYRight };
};